function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useCallback, useMemo, useRef, useState } from 'react';
import { useDndMonitor } from '@dnd-kit/core';
import { GridUtils } from '@deephaven/grid';
import { ActionButton, Popper, SearchField } from '@deephaven/components';
import { useResizeObserver } from '@deephaven/react-hooks';
import SortableTree from "./sortable-tree/SortableTree.js";
import "./SearchWithModal.css";
import MemoizedSearchItem from "./SearchItem.js";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function SearchWithModal(_ref) {
  var _searchRef$current3, _searchRef$current4;
  var items = _ref.items,
    onModalOpenChange = _ref.onModalOpenChange,
    onClick = _ref.onClick,
    onDragStart = _ref.onDragStart,
    setSelection = _ref.setSelection;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    searchValue = _useState2[0],
    setSearchValue = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isModalOpen = _useState4[0],
    setIsModalOpen = _useState4[1];
  var searchRef = useRef(null);
  var popperRef = useRef(null);
  var handleModalOpen = useCallback(() => {
    if (isModalOpen) {
      return;
    }
    setIsModalOpen(true);
    onModalOpenChange(true);
  }, [onModalOpenChange, isModalOpen]);
  var handleModalClose = useCallback(() => {
    if (!isModalOpen) {
      return;
    }
    setIsModalOpen(false);
    onModalOpenChange(false);
  }, [onModalOpenChange, isModalOpen]);
  var handleInputChange = useCallback(value => {
    // Open in case the user hit escape to close the modal then started typing
    // without blurring the input
    handleModalOpen();
    setSearchValue(value);
  }, [handleModalOpen]);
  var handleInputBlur = useCallback(e => {
    if (!popperRef.current || !popperRef.current.element.contains(e.relatedTarget)) {
      handleModalClose();
    }
  }, [handleModalClose]);
  var handleModalBlur = useCallback(e => {
    var _searchRef$current;
    var searchElement = (_searchRef$current = searchRef.current) === null || _searchRef$current === void 0 ? void 0 : _searchRef$current.getInputElement();
    if (!searchElement || !searchElement.contains(e.relatedTarget)) {
      handleModalClose();
    }
  }, [handleModalClose]);
  var handleDragStart = useCallback(event => {
    onDragStart === null || onDragStart === void 0 || onDragStart(event);
    handleModalClose();
  }, [onDragStart, handleModalClose]);
  useDndMonitor({
    onDragStart: isModalOpen ? handleDragStart : undefined
  });
  var handleClick = useCallback((item, event) => {
    onClick(item, event);
    if (!event.shiftKey && !GridUtils.isModifierKeyDown(event)) {
      handleModalClose();
    }
  }, [onClick, handleModalClose]);
  var handleItemKeyDown = useCallback((item, event) => {
    var key = event.key;
    if (key === 'Enter') {
      // Select item and close modal
      event.preventDefault();
      event.stopPropagation();
      setSelection([item]);
      handleModalClose();
    } else if (key === 'ArrowDown') {
      var _event$currentTarget$;
      // Move focus to the next item
      event.preventDefault();
      event.stopPropagation();
      var nextElement = (_event$currentTarget$ = event.currentTarget.parentElement) === null || _event$currentTarget$ === void 0 || (_event$currentTarget$ = _event$currentTarget$.nextElementSibling // The parent item-wrapper elements are siblings, not the tree-items
      ) === null || _event$currentTarget$ === void 0 ? void 0 : _event$currentTarget$.querySelector('.tree-item[tabindex="0"]');
      nextElement === null || nextElement === void 0 || nextElement.scrollIntoView({
        block: 'nearest'
      });
      nextElement === null || nextElement === void 0 || nextElement.focus();
    } else if (key === 'ArrowUp') {
      var _event$currentTarget$2;
      // Move focus to the previous item
      event.preventDefault();
      event.stopPropagation();
      var prevElement = (_event$currentTarget$2 = event.currentTarget.parentElement) === null || _event$currentTarget$2 === void 0 || (_event$currentTarget$2 = _event$currentTarget$2.previousElementSibling // The parent item-wrapper elements are siblings, not the tree-items
      ) === null || _event$currentTarget$2 === void 0 ? void 0 : _event$currentTarget$2.querySelector('.tree-item[tabindex="0"]');
      if (prevElement) {
        prevElement.scrollIntoView({
          block: 'nearest'
        });
        prevElement.focus();
      } else {
        var _searchRef$current2;
        (_searchRef$current2 = searchRef.current) === null || _searchRef$current2 === void 0 || (_searchRef$current2 = _searchRef$current2.getInputElement()) === null || _searchRef$current2 === void 0 || _searchRef$current2.focus();
      }
    }
  }, [setSelection, handleModalClose]);
  var renderItem = useCallback(_ref2 => {
    var value = _ref2.value,
      item = _ref2.item,
      ref = _ref2.ref,
      handleProps = _ref2.handleProps;
    return /*#__PURE__*/_jsx(MemoizedSearchItem, {
      ref: ref,
      value: value,
      item: item,
      onClick: handleClick,
      onKeyDown: handleItemKeyDown,
      handleProps: handleProps
    }, item.id);
  }, [handleClick, handleItemKeyDown]);

  // Detect if the user resizes the panel height while the popper is open
  useResizeObserver((_searchRef$current3 = searchRef.current) === null || _searchRef$current3 === void 0 || (_searchRef$current3 = _searchRef$current3.getInputElement()) === null || _searchRef$current3 === void 0 ? void 0 : _searchRef$current3.closest('.visibility-ordering-builder'), () => {
    var _popperRef$current;
    (_popperRef$current = popperRef.current) === null || _popperRef$current === void 0 || _popperRef$current.scheduleUpdate();
  });
  var filteredItems = useMemo(() => {
    if (searchValue === '') {
      return items;
    }
    var lowerSearch = searchValue.toLowerCase();
    return items.filter(item => item.id.toLowerCase().includes(lowerSearch));
  }, [items, searchValue]);
  var handleSearchKeyDown = useCallback(
  // Close on escape with empty search.
  // If there is a search value, let the input handle the escape to clear the search.
  e => {
    if (e.key === 'Escape' && searchValue === '') {
      handleModalClose();
    }
    if (e.key === 'Enter' && filteredItems.length > 0) {
      e.preventDefault();
      // Select the first item in the list
      var firstItem = filteredItems[0];
      setSelection([firstItem]);
      handleModalClose();
    }
    if (e.key === 'ArrowDown' && filteredItems.length > 0) {
      var _popperRef$current2;
      e.preventDefault();
      // Focus the first item in the list
      var item = (_popperRef$current2 = popperRef.current) === null || _popperRef$current2 === void 0 ? void 0 : _popperRef$current2.element.querySelector('.tree-item[tabindex="0"]');
      item === null || item === void 0 || item.focus();
    }
  }, [setSelection, filteredItems, handleModalClose, searchValue]);
  var handleSelectMatching = useCallback(() => {
    setSelection(filteredItems);
    handleModalClose();
  }, [filteredItems, setSelection, handleModalClose]);
  var hasMultipleSelection = useMemo(() => {
    var foundOne = false;
    return filteredItems.some(item => {
      if (item.selected) {
        if (foundOne) {
          return true;
        }
        foundOne = true;
      }
      return false;
    });
  }, [filteredItems]);
  var hasMultipleMatches = searchValue !== '' && filteredItems.length > 1;
  var showFooterButtons = hasMultipleSelection || hasMultipleMatches;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SearchField, {
      "aria-label": "Search columns",
      ref: searchRef,
      value: searchValue,
      onChange: handleInputChange,
      onFocus: handleModalOpen,
      onBlur: handleInputBlur,
      onKeyDown: handleSearchKeyDown
    }), /*#__PURE__*/_jsx(Popper, {
      ref: popperRef,
      isShown: isModalOpen,
      interactive: true,
      keepInParent: true,
      onBlur: handleModalBlur,
      onExited: handleModalClose // May exit due to escape which does not trigger blur
      ,
      options: {
        placement: 'bottom-end',
        modifiers: {
          preventOverflow: {
            priority: ['top']
          },
          flip: {
            enabled: false
          }
        }
      },
      referenceObject: (_searchRef$current4 = searchRef.current) === null || _searchRef$current4 === void 0 ? void 0 : _searchRef$current4.getInputElement(),
      className: "visibility-search-list",
      children: /*#__PURE__*/_jsx("div", {
        className: "visibility-search-list-inner",
        children: filteredItems.length === 0 ? /*#__PURE__*/_jsx("div", {
          className: "no-results",
          children: "No matching columns"
        }) : /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("div", {
            className: "search-tree-container",
            children: /*#__PURE__*/_jsx(SortableTree, {
              items: filteredItems,
              withDepthMarkers: false,
              renderItem: renderItem
            })
          }), showFooterButtons && /*#__PURE__*/_jsxs("div", {
            className: "footer-buttons",
            children: [hasMultipleSelection && /*#__PURE__*/_jsx(ActionButton, {
              isQuiet: true,
              onPress: handleModalClose,
              children: "Select Group"
            }), hasMultipleMatches && /*#__PURE__*/_jsx(ActionButton, {
              isQuiet: true,
              onPress: handleSelectMatching,
              children: "Select Matching"
            })]
          })]
        })
      })
    })]
  });
}
export default SearchWithModal;
//# sourceMappingURL=SearchWithModal.js.map